export const PASSWORD_PLACEHOLDER = '英(大小)数記号を含む10文字以上';
